export interface LegalSection {
  id: string;
  title: string;
  body: string[];
}

export const termsSections: LegalSection[] = [
  {
    id: "agreement",
    title: "Agreement",
    body: [
      "These terms govern your use of PolyLexa's website and apps. By creating an account you agree to them. If you use PolyLexa on behalf of an organisation, you confirm you can accept these terms for it.",
    ],
  },
  {
    id: "accounts",
    title: "Your account",
    body: [
      "You're responsible for keeping your login details safe and for activity under your account. You must be at least 13 years old, or have permission from a parent or guardian.",
    ],
  },
  {
    id: "content",
    title: "Learning content",
    body: [
      "Course materials, including content licensed from Loescher Editore, are provided for your personal learning. You may not copy, resell or redistribute them.",
      "Words and phrases you save through the translator belong to you and can be exported or deleted at any time.",
    ],
  },
  {
    id: "subscriptions",
    title: "Subscriptions & payments",
    body: [
      "Paid plans renew automatically until cancelled. You can cancel from Profile → Subscription; you'll keep access until the end of the current period. Trials convert to a paid plan unless cancelled before they end.",
    ],
  },
  {
    id: "acceptable-use",
    title: "Acceptable use",
    body: ["Don't misuse the service: no scraping, reverse engineering, abusive behaviour, or attempts to access other people's accounts."],
  },
  {
    id: "changes",
    title: "Changes to these terms",
    body: ["We'll tell you about material changes by email or in the app at least 30 days before they take effect."],
  },
];

export const privacySections: LegalSection[] = [
  {
    id: "summary",
    title: "The short version",
    body: [
      "We collect what we need to teach you well — your courses, progress and saved words — and nothing we don't. We never sell your data.",
    ],
  },
  {
    id: "collect",
    title: "What we collect",
    body: [
      "Account details (name, email), learning activity (lessons, answers, streaks), words you save, and basic device information for security and troubleshooting.",
      "Voice recordings for pronunciation exercises are processed by your browser's speech service and are not stored by PolyLexa.",
    ],
  },
  {
    id: "use",
    title: "How we use it",
    body: ["To run your lessons, personalise reviews, blend saved words into exercises, send reminders you've opted into, and improve the product in aggregate."],
  },
  {
    id: "share",
    title: "Who we share it with",
    body: ["Payment processors for billing, and infrastructure providers that host our service under strict agreements. Content partners like Loescher never receive your personal data."],
  },
  {
    id: "rights",
    title: "Your rights",
    body: ["You can access, export, correct or delete your data at any time from Settings, or by contacting privacy@polylexa.com."],
  },
  {
    id: "retention",
    title: "Retention",
    body: ["We keep your data while your account is active and delete it within 30 days of account deletion, except where the law requires longer."],
  },
];
